// extracted by mini-css-extract-plugin
export default {"container":"ImageHalfCircle_container__T-2wg","circle":"ImageHalfCircle_circle__9B9Yg"};